import { initializeDB } from '../config/db';
import { WELDER_QUALIFICATION_RELEASE_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

/**
 * On-Site Welder Qualification & Release (LC-36A).
 *
 * Черновики живут в IndexedDB; отправленная форма удаляется из стора и
 * дальше существует только на сервере (Symfony) — поэтому GET-методов тут нет.
 */
export const welderQualificationReleaseService = {
    async submit(release) {
        const response = await axiosInstance.post('/welder-qualification-release/submit', release);
        return response.data;
    },

    async saveToIndexedDB(formData) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(WELDER_QUALIFICATION_RELEASE_STORE, 'readwrite');
            const store = tx.objectStore(WELDER_QUALIFICATION_RELEASE_STORE);

            const dataToSave = {
                ...formData,
                updatedAt: new Date().toISOString(),
            };

            if (!dataToSave.createdAt) {
                dataToSave.createdAt = new Date().toISOString();
            }

            await store.put(dataToSave);
            await tx.done;

            return dataToSave;
        } catch (error) {
            console.error('Error saving Welder Qualification & Release to IndexedDB:', error);
            throw error;
        }
    },

    async getFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(WELDER_QUALIFICATION_RELEASE_STORE, 'readonly');
            const store = tx.objectStore(WELDER_QUALIFICATION_RELEASE_STORE);
            const data = await store.get(uuid);
            await tx.done;
            return data;
        } catch (error) {
            console.error('Error reading Welder Qualification & Release from IndexedDB:', error);
            throw error;
        }
    },

    async getAllFromIndexedDB() {
        try {
            const db = await initializeDB();
            const tx = db.transaction(WELDER_QUALIFICATION_RELEASE_STORE, 'readonly');
            const store = tx.objectStore(WELDER_QUALIFICATION_RELEASE_STORE);
            const data = await store.getAll();
            await tx.done;
            return data || [];
        } catch (error) {
            console.error('Error reading Welder Qualification & Release list from IndexedDB:', error);
            return [];
        }
    },

    async deleteFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction(WELDER_QUALIFICATION_RELEASE_STORE, 'readwrite');
            const store = tx.objectStore(WELDER_QUALIFICATION_RELEASE_STORE);
            await store.delete(uuid);
            await tx.done;
        } catch (error) {
            console.error('Error deleting Welder Qualification & Release from IndexedDB:', error);
            throw error;
        }
    },
};
